import { InjectionToken } from '@angular/core';
import { FirebaseApp, FirebaseOptions } from 'firebase/app';
import { Auth as FirebaseAuth } from 'firebase/auth';

export const FIREBASE_OPTIONS = new InjectionToken<FirebaseOptions>('FIREBASE_OPTIONS');
export const FIREBASE_APP = new InjectionToken<FirebaseApp>('FIREBASE_APP');
export const FIREBASE_AUTH = new InjectionToken<FirebaseAuth>('FIREBASE_AUTH');
